export default __webpack_public_path__ + "static/media/facebook.d04a51db.svg";